export enum EGroupedItemsType {
    String = 'string',
    Text = 'text',
    Boolean = 'boolean',
    Title = 'title',
    Select = 'select',
    AliasFilter = 'aliasFilter',
    CityFilter = 'citiesFilter',
    TextAlignment = 'textAlignment',
    Button = 'button',
    ButtonRemove = 'buttonRemove',
    ColorPicker = 'colorPicker',
    File = 'file',
    RTE = 'rte',
    Margin = 'margin',
    TabColumn = 'tabColumn',
    Hidden = 'hidden',
}

export type TPropValues = {
    [key: string]: any,
}

export interface IGroupedProps {
    key?: string;
    groupName?: string;
    name?: string;
    label?: string;
    size?: 'lg' | 'sm';
    order?: number;
    withBreakpoints: boolean;
    type?: EGroupedItemsType;
    value?: string;
    items?: IGroupedProps[];
    props?: TPropValues;
    render?: JSX.Element;
}

export interface IGroupedPropsNormalized {
    default?: IGroupedProps;
    [key: string]: IGroupedProps;
}
